import classes from './Selected.module.sass'
import heart from '../../../assets/images/icons/heart.svg'
import heart_check from '../../../assets/images/icons/heart_check.svg'


type Props = {
  selected: boolean
  onClick: () => void
  visible?: boolean
}

export const Selected = ({ selected, onClick, visible = true }: Props) => {
  return (
    <div className={classes.Container}>
      {visible && (
        <img
          src={selected ? heart_check : heart}
          className={classes.Icon}
          onClick={onClick}
          alt="Избранное"
        />
      )}
    </div>
  )
}
